/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/user_attributes';
import '../../common/token';
import './status';
import '../../common/variable';
const $root = $protobuf.roots['square-experiments'] || ($protobuf.roots['square-experiments'] = new $protobuf.Root());
$root.addJSON({
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "experiments": {
                "nested": {
                  "message": {
                    "nested": {
                      "GetExperimentsRequest": {
                        "fields": {
                          "experimentRequests": {
                            "type": "squareup.feature.relay.experiments.message.GetExperimentRequest",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "userAttributes": {
                            "type": "squareup.feature.relay.common.UserAttributes",
                            "id": 2,
                            "rule": "optional"
                          },
                          "projectId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetExperimentRequest": {
                        "fields": {
                          "experimentName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "userToken": {
                            "type": "squareup.feature.relay.common.Token",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetExperimentsResponse": {
                        "fields": {
                          "experimentResponses": {
                            "type": "squareup.feature.relay.experiments.message.GetExperimentResponse",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "userAttributes": {
                            "type": "squareup.feature.relay.common.UserAttributes",
                            "id": 2,
                            "rule": "optional"
                          },
                          "status": {
                            "type": "squareup.feature.relay.experiments.message.Status",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetExperimentResponse": {
                        "fields": {
                          "status": {
                            "type": "squareup.feature.relay.experiments.message.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "experimentName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "userToken": {
                            "type": "squareup.feature.relay.common.Token",
                            "id": 3,
                            "rule": "optional"
                          },
                          "variantName": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "variables": {
                            "type": "squareup.feature.relay.common.Variable",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "isActive": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE GetExperimentsRequest @ squareup/feature/relay/experiments/message/get_experiments.proto at 14:1
 */
export const GetExperimentsRequest = $root.lookupType('squareup.feature.relay.experiments.message.GetExperimentsRequest');
fixType(GetExperimentsRequest, {
  experimentRequests: {
    required: true
  }
});
Builder.createAndAttachToType(GetExperimentsRequest);
/**
 * SOURCE GetExperimentRequest @ squareup/feature/relay/experiments/message/get_experiments.proto at 22:1
 */
export const GetExperimentRequest = $root.lookupType('squareup.feature.relay.experiments.message.GetExperimentRequest');
fixType(GetExperimentRequest, {
  experimentName: {
    required: true,
    notEmpty: true
  },
  userToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetExperimentRequest);
/**
 * SOURCE GetExperimentsResponse @ squareup/feature/relay/experiments/message/get_experiments.proto at 29:1
 */
export const GetExperimentsResponse = $root.lookupType('squareup.feature.relay.experiments.message.GetExperimentsResponse');
fixType(GetExperimentsResponse);
Builder.createAndAttachToType(GetExperimentsResponse);
/**
 * SOURCE GetExperimentResponse @ squareup/feature/relay/experiments/message/get_experiments.proto at 38:1
 */
export const GetExperimentResponse = $root.lookupType('squareup.feature.relay.experiments.message.GetExperimentResponse');
fixType(GetExperimentResponse, {
  experimentName: {
    required: true,
    notEmpty: true
  },
  userToken: {
    required: true
  },
  isActive: {
    required: true
  }
});
Builder.createAndAttachToType(GetExperimentResponse);